import { setCookie, getCookie, removeCookie } from 'typescript-cookie';

export const X_DEVICE_CODE = 'x-device-code';

export const setXDeviceCode = (code: string): void => {
    setCookie(X_DEVICE_CODE, code, { sameSite: 'Strict' });
};

export const getXDeviceCode = (): string => {
    return getCookie(X_DEVICE_CODE) || '';
};

export const deleteXDeviceCode = (): void => {
    removeCookie(X_DEVICE_CODE);
};
